var _rect, _g, _use, _use2, _use3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 512,
    rx: "15%",
    width: 512
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e01e5a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m149 305a39 39 0 0 1 -78 0c0-22 17-39 39-39h39zm19 0a39 39 0 0 1 78 0v97a39 39 0 0 1 -78 0z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#36c5f0",
    transform: "matrix(0 1 -1 0 512 0)",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#2eb67d",
    transform: "matrix(-1 0 0 -1 512 512)",
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "#ecb22e",
    transform: "matrix(0 -1 1 0 0 512)",
    xlinkHref: "#a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.461658a78c3c88ea0fc8d6d667b944e4.svg";
export { ForwardRef as ReactComponent };